import Worker from '@/entity/Worker';
export default class WorkerVM extends Worker {
    /**
     * @param WorkerVM domain WorkerManagement
     */
    // eslint-disable-next-line no-useless-constructor
    constructor(worker) {
        super(worker);
    }
    get convictionStatusForUser() {
        return {
            DOCUMENT_SUBMITTED: '미해당',
            CONVICTED: '해당',
            DOCUMENT_NOT_SUBMITTED: '미제출',
            NONE: '미제출',
        }[this.convictionStatus];
    }
}
